// DO NOT EDIT MANUALLY! This file is generated from Airtable: "OffchainTrading-BondingCurve"

import { Value } from './offchainTradingBondingCurve.types';

// prettier-ignore
const offchainTradingBondingCurve: Value[] = [
  {
    "buy_multiplier": 1,
    "exponent": 0.08,
    "initial_price": 1000000,
    "name": "Pump Fun Curve",
    "sell_multiplier": 1,
    "step_size": 1
  }
];
export default offchainTradingBondingCurve;
